module.exports = __webpack_public_path__ + "static/contactexample-0455ef65c533d9b2884a04d9bbc5ad5f.svg";